import React, { useState } from 'react';
import styled from 'styled-components';
import useLocale from '../../hooks/useLocale';

const ToggleLink = styled.button`
  background: none;
  border: none;
  color: ${p => p.theme.colors.text.muted};
  font-size: 13px;
  cursor: pointer;
  padding: ${p => p.theme.spacing[2]}px 0;
  text-decoration: underline;
  margin-top: ${p => p.theme.spacing[5]}px;
`;

const ExplainerBox = styled.div`
  max-width: 600px;
  margin: ${p => p.theme.spacing[3]}px auto 0;
  padding: ${p => p.theme.spacing[4]}px;
  background: #FFF9F0;
  border: 1px solid rgba(239,108,0,0.2);
  border-radius: 8px;
  font-size: 13px;
  line-height: 1.7;
  color: ${p => p.theme.colors.text.secondary};
  text-align: left;
  font-family: 'Noto Sans Tamil', ${p => p.theme.typography.fontFamily};

  p { margin: 0 0 ${p => p.theme.spacing[2]}px; }
  p:last-child { margin-bottom: 0; }
`;

const Title = styled.h3`
  font-size: 15px;
  color: #8B3A00;
  margin: 0 0 ${p => p.theme.spacing[2]}px;
  font-weight: 600;
`;

const AboutGanesha = ({ lang }) => {
  const t = useLocale(lang, 'ganeshaPrashnavali');
  const [expanded, setExpanded] = useState(false);

  const toggleLabel = expanded
    ? (t.aboutToggleOpen || 'Close')
    : (t.aboutToggleClosed || 'What is Ganesha Prashnavali?');

  return (
    <div>
      <ToggleLink onClick={() => setExpanded(!expanded)} aria-expanded={expanded}>
        {toggleLabel}
      </ToggleLink>

      {expanded && (
        <ExplainerBox>
          <Title>{t.aboutToggleClosed || 'What is Ganesha Prashnavali?'}</Title>
          <p>{t.aboutOrigin || 'This tool is based on the Ganesha Purana tradition of divination through 64 cells.'}</p>
          <p>{t.aboutHow || '64 cells are arranged in an 8×8 grid. Each cell maps to a specific oracle response with a verse, interpretation, and auspiciousness level.'}</p>
          <p>{t.aboutIntention || 'Hold a decision in mind, tap a cell, and receive Ganapathi\'s guidance.'}</p>
          <p>{t.aboutCulture || 'Used for yes/no decisions across Tamil temples as a form of spiritual consultation.'}</p>
        </ExplainerBox>
      )}
    </div>
  );
};

export default AboutGanesha;
